module.exports = __webpack_public_path__ + "img/a20.5f45b83b.svg";